/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Suspended_Cannot_CheckinInputs */



/**
* | output |
* | --- |
* | "Suspended players cannot participate" |
*
* @param {Error_Suspended_Cannot_CheckinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const error_suspended_cannot_checkin = /** @type {((inputs?: Error_Suspended_Cannot_CheckinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Suspended_Cannot_CheckinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs suspendus ne peuvent pas participer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores suspendidos no pueden participar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Jogadores suspensos não podem participar")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori sospesi non possono partecipare")
	return /** @type {LocalizedString} */ ("Suspended players cannot participate")
});